import { Head, Link, useForm } from '@inertiajs/react'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { passwords, sessions } from '@/routes'

export default function Forgot() {
  const form = useForm({ email_address: '' })

  return (
    <Card>
      <Head title="Reset password" />
      <CardHeader>
        <CardTitle>Reset your password</CardTitle>
      </CardHeader>
      <CardContent>
        <form
          className="grid gap-4"
          onSubmit={(e) => {
            e.preventDefault()
            form.submit(passwords.create())
          }}
        >
          <div className="grid gap-2">
            <Label htmlFor="email">Email</Label>
            <Input
              id="email"
              type="email"
              value={form.data.email_address}
              onChange={(e) => form.setData('email_address', e.target.value)}
              required
            />
          </div>
          <Button type="submit" disabled={form.processing}>
            Email me a reset link
          </Button>
          <Link href={sessions.new()} className="text-center text-sm text-muted-foreground underline">
            Back to sign in
          </Link>
        </form>
      </CardContent>
    </Card>
  )
}
